<div class="action-buttons">
  <div class="flex-grow">
    @let selectedRowsLength = $selectedRows().length;
    @if (selectedRowsLength) {
      <span class="icon-right">
        {{ selectedRowsLength }} Selected &nbsp;
        <span (click)="onResetSelection()">&times;</span>
      </span>
    }

    @if (enableDownload() && isDataAvailable) {
      <wcg-button
        color="tertiary"
        size="slim"
        (click)="handleDownloadDocuments()"
      >
        <mat-icon fontSet="material-icons-outlined">download</mat-icon>
        {{ selectedRowsLength === 0 ? "Download All" : "Download" }}</wcg-button
      >
    }

    @if (enableExport()) {
      <wcg-button
        color="tertiary"
        size="slim"
        class="export-btn"
        [matMenuTriggerFor]="exportMenu"
        (click)="toggleExport($event)"
      >
        Export All
        <mat-icon>{{
          exportMenuOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
        }}</mat-icon></wcg-button
      >
    }

    <mat-menu #exportMenu="matMenu">
      <button mat-menu-item (click)="handleExport('csv')">Export as CSV</button>
      <button mat-menu-item (click)="handleExport('pdf')">Export as PDF</button>
    </mat-menu>

    @if (enableDelete() && isDataAvailable) {
      <wcg-button
        class="delete-btn"
        color="tertiary-warn"
        size="slim"
        (click)="handleDeleteDocuments()"
      >
        <mat-icon>delete</mat-icon
        >{{ selectedRowsLength === 0 ? "Delete All" : "Delete" }}</wcg-button
      >
    }
  </div>
  @if (enableGridView()) {
    <div class="flex flex-col gap-2 items-start">
      <wcg-grid-view-drop-down [gridViewType]="gridType()" class="w-full" />
      <div class="flex">
        @if (enableRevert()) {
          <wcg-button
            color="tertiary"
            size="slim"
            (click)="revertGridSettings()"
          >
            <mat-icon>refresh</mat-icon>Revert Grid Setting</wcg-button
          >
        }
        <wcg-create-grid-view
          label="Save View"
          [data]="tableData()"
          [gridViewType]="gridType()"
          [isTableColumnChanged]="isTableColumnChanged()"
          [isDisabled]="totalGridViews() >= 5"
        />
      </div>
    </div>
  }
</div>
